import {Component, Inject, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { addZeitStart } from '../../store/actions/Zeit-add.actions';
import {select, Store} from '@ngrx/store';
import {Zeitstate} from '../../store/reducer/zeiterfassung.reducer';
import {loadSpesenartenStart} from '../../store/actions/spesenart.actions';
import {ZeiterfassungFormdialogNeuComponent} from '../zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {loadSpesenStart} from '../../store/actions/getAllSpesen.actions';
import {SpesenartFormdialogComponent} from '../spesenart-form-dialog/spesenart-formdialog.component';
import {loadInactiveSpesenartenStart} from '../../store/actions/getInactiveSpesenart.action';


export interface DialogData {
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  code: string;
  bezeichnung: string;
  ansatzInt: number;
  ansatzExt: number;
  konto: number;
  firmaId: number;
  id: number;
  projektId: number;

}


@Component({
  selector: 'app-spesenart-pageform',
  templateUrl: './spesenart-pageform.component.html',
  styleUrls: ['./spesenart-pageform.component.scss'],
})



export class SpesenartPageFormComponent implements OnInit{

  public $spesenarten;

  constructor(
    public dialogRef: MatDialogRef<SpesenartPageFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public store: Store<{ zeiterfassung: Zeitstate }>,
    public dialog: MatDialog
  )
  {
    dialogRef.disableClose = true;
    this.$spesenarten = store.pipe(select((state) => state.zeiterfassung.spesenarten));
  }

  public ngOnInit(): void {
    sessionStorage.setItem('spesenartIsAktiv', '1');
    this.store.dispatch(loadSpesenartenStart());
  }


  public handleSubmitClick(): void{
    this.dialogRef.close(true);

  }

  public addSpesenart(): void{

    const dialogEdit = this.dialog.open(SpesenartFormdialogComponent, {
      data: {
        title: 'pages.zeitverwaltung.spesenartDialog.addTitle',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        code: null,
        bezeichnung: null,
        ansatzInt: 0.00,
        ansatzExt: 0.00,
        konto: null,
        firmaId: null,
        id: null,
        projektId: null,
      },
    });
  }

  public showInactive(event): void {
      if (event.checked){
        sessionStorage.setItem('spesenartIsAktiv', '0' );
        // this.store.dispatch(loadInactiveSpesenartenStart());
      }
      else{
        sessionStorage.setItem('spesenartIsAktiv', '1' );
        // this.store.dispatch(loadSpesenartenStart());
      }
      this.store.dispatch(loadSpesenartenStart());
  }
}

